export function getUserDisplayName(userData: any) {
    const fullName = userData?.display_name
        || [userData?.first_name, userData?.last_name].filter(Boolean).join(' ');
    return fullName || userData?.username || '';
}

export function storeAuthenticatedUser(userData: any) {
    localStorage.removeItem('company');
    localStorage.setItem('username', userData?.username || '');
    localStorage.setItem('userDisplayName', getUserDisplayName(userData));
    localStorage.setItem('access', JSON.stringify(userData?.access || {}));
}
